if (typeof window.FormData === 'undefined'
    || typeof window.FormData.prototype.get === 'undefined'
    || typeof window.FormData.prototype.append === 'undefined'
    || typeof window.FormData.prototype.delete === 'undefined'
    || typeof window.FormData.prototype.entries === 'undefined') {
  require.ensure(['formdata-polyfill'], (require) => {
    window.FormData = require('formdata-polyfill');
  });
}
